import(/* webpackMode: "eager" */ "/vercel/path0/apps/quark/src/app/global-error.tsx");
